import { faClose, faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./MusicBg.css"; // Pastikan file CSS ini mengatur animasi teks berjalan

export default function MusicBg({ onClick, statsPlay, visible, onClose }) {
  return (
    // 1. Z-INDEX TERTINGGI: z-[100] agar pasti berada di atas segalanya.
    // 2. POINTER EVENTS: None di container luar, agar tidak mengganggu klik di sekitarnya.
    // 3. ANIMASI CONTAINER: Animasi dipindah ke div induk agar kedua tombol naik-turun bersamaan secara mulus.
    <div
      className={`fixed z-[100] bottom-6 right-4 md:right-8 flex gap-2 pointer-events-none transition-all duration-500 ease-in-out ${
        visible
          ? "translate-y-0 opacity-100 visible"
          : "translate-y-32 opacity-0 invisible"
      }`}
    >
      {/* Tombol Play/Pause dengan info lagu */}
      {/* 4. POINTER-EVENTS-AUTO: Mengembalikan fungsi klik hanya pada tombol ini */}
      <button
        onClick={onClick}
        className="pointer-events-auto text-white flex items-center justify-between max-w-[200px] md:max-w-[250px] bg-black/85 backdrop-blur-md hover:bg-black font-bold rounded-2xl px-4 py-3 shadow-2xl border border-white/10 active:scale-95 transition-all cursor-pointer"
      >
        <div className="scrolling-text-container overflow-hidden w-[120px] md:w-[150px]">
          <p className="scrolling-text text-xs md:text-sm whitespace-nowrap">
            George Benson - Nothing's Gonna Change My Love For You
          </p>
        </div>
        <FontAwesomeIcon
          className={`ml-3 text-lg md:text-xl transition-colors ${statsPlay ? "text-[#d4af37]" : "text-white"}`}
          icon={statsPlay ? faPause : faPlay}
        />
      </button>

      {/* Tombol Close */}
      {/* Diubah menjadi kotak presisi w-12 h-12 (48x48px) sesuai standar area sentuh minimum jempol di Mobile */}
      <button
        onClick={onClose}
        className="pointer-events-auto text-white flex items-center justify-center w-[48px] h-[48px] bg-black/85 backdrop-blur-md hover:bg-[#5C1420] font-bold rounded-2xl shadow-2xl border border-white/10 active:scale-95 transition-all cursor-pointer text-xl"
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
    </div>
  );
}
